export { default } from './toImmutableStack'
